import { Person } from '../redux/reducers/clients'
import { fetchRequest } from '../services/http.service'

const URL = '/persons'

export const getPersonsRequest = () => fetchRequest.get<Person[]>(URL)
